import { useLanguage } from "@/contexts/LanguageContext";
import { BRAND } from "@/i18n/translations";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#070707] text-[#FAFAFA] pt-20 pb-8 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 pb-16">
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logoUrl}
                alt="RED FLAG"
                className="h-10 w-10 object-contain"
              />
              <div className="font-display uppercase text-2xl tracking-wide">
                <span className="text-redflag">Red</span>{" "}
                <span className="text-white">Flag</span>
              </div>
            </div>
            <p className="mt-4 text-white/55 max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
            <p className="mt-6 font-mono-plex text-xs text-white/40 uppercase tracking-widest">
              {t.footer.address}
            </p>
          </div>

          <FooterCol
            title={t.footer.cols.platform}
            links={[
              t.footer.links.podcast,
              t.footer.links.academy,
              t.footer.links.membership,
              t.footer.links.selftest,
            ]}
            testid="footer-col-platform"
          />
          <FooterCol
            title={t.footer.cols.ecosystem}
            links={[
              t.footer.links.sat,
              t.footer.links.herzbewegung,
              t.footer.links.about,
            ]}
            testid="footer-col-ecosystem"
          />
          <FooterCol
            title={t.footer.cols.legal}
            links={[
              t.footer.links.imprint,
              t.footer.links.privacy,
              t.footer.links.terms,
            ]}
            testid="footer-col-legal"
          />
        </div>

        {/* Huge brand mark */}
        <div
          aria-hidden="true"
          className="select-none font-display uppercase leading-[0.8] tracking-tight text-[24vw] md:text-[18vw] border-t border-white/10 pt-6 flex items-center gap-4"
        >
          <span className="text-redflag">!</span>
          <span className="text-white">RED FLAG</span>
        </div>

        <div className="mt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 font-mono-plex text-xs text-white/45 uppercase tracking-widest">
          <span>
            © {year} {BRAND.name} Media · {t.footer.rights}
          </span>
          <span>{BRAND.domain}</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links, testid }) {
  return (
    <div data-testid={testid} className="col-span-1 md:col-span-2">
      <h4 className="overline mb-4 text-white/50">{title}</h4>
      <ul className="space-y-2 text-sm">
        {links.map((l, i) => (
          <li key={i}>
            <a
              href="#"
              data-testid={`${testid}-link-${i}`}
              className="text-white/80 hover:text-redflag transition-colors"
            >
              {l}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
